<script>
    // import { currency_formatter } from "../globals.js";
    import {querystring} from 'svelte-spa-router'
    import { onDestroy, onMount } from 'svelte';
    // import JobTools from './jobtools.svelte';
    // import ResponsiveTable from '../utils/responsivetable3.svelte';
    import Header from "../header.svelte";
    // import Flatpickr from "../utils/Flatpickr.svelte";
    import {link, location, push, pop, replace} from 'svelte-spa-router';
    import IFTAInput from "../../utils/iftainput.svelte";


    let is_busy = false;
    let is_mounted = false;

    $: content_title = "Contents - Coupon";

    onMount(async () => {
        setTimeout(()=>{is_mounted = true;}, 250);
    });

    let button_title = "Edit";
    let disabled = true;
    let image_file;

    let header_copy = "Coupon header copy";
    let body_copy = 'Information about the coupon';
    let terms_copy = "Terms regarding the coupoin";



    let email_subject = 'You have received a coupon code from "sender\'s FULL name"';
    let email_content = 'Sender\'s full name sent you a coupon code good for (amount off or discount percent)\nSender\'s first name\'s message: This is a gift for you.\nTo redeem your yard cleanup coupon code, enter an address on “customer’s home page link.com” and use the following code during checkout:\n“Coupon code”';

    function togglePublish() {
// console.log(image_file);
        if(!disabled) {
            // need to publish here
        }

        disabled = !disabled;

        if(!disabled) {
            button_title = "Publish";
        }else{
            button_title = "Edit";
        }
    }

	
</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />
<div class="contentholder">

    <div class="section">
        <div class="sectiontitle"><i class="far fa-newspaper"></i> Coupon Page Settings</div>
        <div class="imagesholder">
            <IFTAInput
                label="Coupon Page Header Image"
                type="singleimage"
                image_type="image"
                file_accept=".jpg, .jpeg, .png"
                show_image_previews={true}
                bind:value={image_file}
                bind:disabled={disabled}
                helper_text="This image will appear at the top of your coupon page."
            />
        </div>
    
        <IFTAInput 
            label="Header Text"
            type="textarea"
            bind:value={header_copy}
            bind:disabled={disabled}
            helper_text="This text will appear in the header of your coupon page."
        />
    
        <IFTAInput 
            label="Body Text"
            type="textarea"
            bind:value={body_copy}
            bind:disabled={disabled}
            helper_text="This text will appear as the main text of your coupon page."
        />
    
        <IFTAInput 
            label="Terms Text"
            type="textarea"
            bind:value={terms_copy}
            bind:disabled={disabled}
            helper_text="This text will appear as small text at the bottom of your coupon page text."
        />
    
    </div>

    <div class="section">
        <div class="sectiontitle"><i class="fas fa-envelope-open-text"></i> Coupon Email Settings</div>

        <IFTAInput 
            label="Email Subject"
            type="text"
            bind:value={email_subject}
            bind:disabled={disabled}
            helper_text="This text will appear in the subject line of the email."
        />
        <IFTAInput 
            label="Email Content"
            type="textarea"
            bind:value={email_content}
            bind:disabled={disabled}
            helper_text="This text will appear as the content of the email."
        />
    

    </div>

    <div class="buttonholder">
        <button on:click={()=>{togglePublish();}}>{button_title}</button>
    </div>

</div>

<style>
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }

    .formrow {
        padding: 0px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .section_old {
        margin-top: 25px;
        width: 100%;
    }

    .section_old .sectiontitle_old {
        width: 100%;
        font-size: 20px;
        color: white;
        background-color: #1769aa;
        margin-bottom: 10px;
    }
    .section_old .sectiontitle_old i{
        width: 25px;
        display: none;

    }
    .section_old .sectionsubtitle_old {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
        color: white;
        background-color: #1769aa;
        padding: 5px;
        box-sizing: border-box;
    }
    .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .column{
        padding: 0px;
        margin: 0px;
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .row{
        padding: 0px;
        margin: 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }

    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    .contentholder {
        padding: 0px;
    }

    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
        /* width: 100%; */
        background-color: #357a38;
        color: white;
    }
    :global(.flatpickr-input) {
        /* background-color: #ff9100; */
        /* color: white; */
        width: 250px;
    }
    .toolsholder {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        box-sizing: border-box;
    }

    :global(.toolsholder .group) {
        padding-left: 10px;
        padding-right: 10px;
    }
    .highlight {
        border: 1px solid black;
        padding: 10px;
        box-sizing: border-box;
    }
    .newitembuttonholder {
        margin-left: 10px;
        width: 40%;
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }

    .newitembuttonholder button{
        max-width: 100px;
        width: 100px;
        height: 40px;
    }

    .newitembuttonholder button.savebutton{
        color: #1c54b2;
        background-color: white;
     }

    .newitembuttonholder button.cancelbutton{
        color: #b2102f;
        background-color: white;
    }

    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 0px;
            width: 100%;
        }
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }

        .section_old {
            padding: 0px;
        }
        .sectioninfo {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        .column{
            padding: 0px;
            margin: 0px;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        .row{
            padding: 0px;
            margin: 0px;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }

        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            /* max-width: 100%; */
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
        :global(.flatpickr-input) {
            /* background-color: #ff9100; */
            /* color: white; */
            width: 100%;
        }
        .toolsholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        :global(.toolsholder .group) {
            padding-left: 0px;
            padding-right: 0px;
        }

        .newitembuttonholder {
            margin-left: 0px;
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        .newitembuttonholder button{
            max-width: 100%;
            width: 100%;
            height: 40px;
        }

        :global(.rowwrap .group) {
            min-width: 100%;
            max-width: 100%;
        }

    }

</style>